// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3H3V7","load1":"Spinner_load1__20rkw"};